import React from "react";
import axios from "axios";
import { useFormik } from "formik";
import * as Yup from "yup";
import "./main.min.css";
import "./bootstrap.min.css";
import "./style.css";

export default function ContactUs() {
  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      mobile: "",
      message: "",
      hotel: "oryza",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required"),
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      mobile: Yup.string().required("Phone number is required"),
      message: Yup.string().required("Message is required"),
    }),
    onSubmit: async (values, { resetForm, setStatus }) => {
      console.log("Submitted values:", values);
       await axios.post(
         "https://zftlwlotwk.execute-api.us-east-1.amazonaws.com/dev/contactForm/",
         { values }
       );
      setStatus({ success: true });
      resetForm();
    },
  });

  return (
    <div id="main">
      <div className="page-wrapper">
        <section className="section p-t-30 p-b-30">
          <div className="container contacttitle">
            <div className="page-heading">
              <h4 className="title-sub title-sub--c8">Have any questions?</h4>
              <h2 className="title-3 contactfont">GET IN TOUCH WITH US</h2>
            </div>
          </div>
        </section>

        <section className="section">
          <div className="container sectionstyle">
            <div className="row no-gutters">
              <div className="col-lg-4">
                <div className="contact-info">
                  <div className="contact-info__item">
                    <h5 className="title--sm2">Address:</h5>
                    <p className="value">
                      No 178, 2/2, Stanley Thilakarathna Mawatha, Nugegoda
                    </p>
                  </div>
                  <div className="contact-info__item">
                    <h5 className="title--sm2">TALK TO US:</h5>
                    <a className="white" href="tel:+94767008800">
                      +94 76 700 8800
                    </a>
                  </div>
                  <div className="contact-info__item">
                    <h5 className="title--sm2">EMAIL US:</h5>
                    <p className="value">
                      <a
                        className="white"
                        href="mailto:reservations@oryzaleisure.com"
                      >
                        reservations@oryzaleisure.com
                      </a>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-8">
                <form
                  className="form-contact js-contact-form"
                  id="contact"
                  onSubmit={formik.handleSubmit}
                >
                  <div className="form-row no-gutters">
                    <div className="col-md-6">
                      <input
                        className="au-input"
                        type="text"
                        id="name"
                        name="name"
                        placeholder="Name*"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.name}
                      />
                      {formik.touched.name && formik.errors.name && (
                        <div className="error">{formik.errors.name}</div>
                      )}

                      <input
                        className="au-input"
                        type="email"
                        id="email"
                        name="email"
                        placeholder="Email Address*"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.email}
                      />
                      {formik.touched.email && formik.errors.email && (
                        <div className="error">{formik.errors.email}</div>
                      )}

                      <input
                        className="au-input"
                        type="text"
                        id="mobile"
                        name="mobile"
                        placeholder="Phone Number*"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.mobile}
                      />
                      {formik.touched.mobile && formik.errors.mobile && (
                        <div className="error">{formik.errors.mobile}</div>
                      )}

                      <input
                        type="hidden"
                        name="hotel"
                        value={formik.values.hotel}
                      />
                    </div>

                    <div className="col-md-6 p-r-0">
                      <textarea
                        className="au-textarea"
                        id="message"
                        name="message"
                        placeholder="Message*"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.message}
                      />
                      {formik.touched.message && formik.errors.message && (
                        <div className="error">{formik.errors.message}</div>
                      )}

                      {formik.status?.success && (
                        <div
                          className="message success"
                          style={{
                            backgroundColor: "green",
                            padding: "10px",
                            color: "#ffffff",
                            marginBottom: "10px",
                            borderRadius: "5px",
                          }}
                        >
                          Your message is successfully sent...
                        </div>
                      )}

                      <div className="text-right">
                        <button className="au-btn au-btn--solid" type="submit">
                          Send message
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="google-maps">
            <iframe
              title="Google Maps Location of 178 Stanley Thilakarathna Mawatha, Nugegoda"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3961.125712334058!2d79.89733570277181!3d6.8755381168804695!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae25a6a871267b1%3A0x58e35a8b2cfd4ef0!2s178%20Stanley%20Thilakarathna%20Mawatha%2C%20Nugegoda!5e0!3m2!1sen!2slk!4v1712650854393!5m2!1sen!2slk"
              width="100%"
              height="500"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </section>
      </div>
    </div>
  );
}
